<template>
 <div></div>
</template>

<script>
export default {
  created() {
    if (this.$route.query) {
      let a = 'biz.social.weakapp://lineCallBack?'
      for (const [key, value] of Object.entries(this.$route.query)) {
        a += `${key}=${value}&`
      }
      a = a.substring(0, a.length - 1)
      window.location.href = a
    }
  },
}
</script>

<style>

</style>
